
import { toHead } from 'vue-datocms'
import { contentPageQuery } from '~/gql/contentPage.graphql'
import PublicHero from '~/components/public/public-hero.vue'
import RichTextSection from '~/components/public/rich-text-section.vue'
import FeaturedGroup from '~/components/public/featured/featured-group.vue'
import { url } from '~/utils/seo'
import SeoPage from '~/components/seo-category/seo-page.vue'

export default {
  components: {
    FeaturedGroup,
    PublicHero,
    RichTextSection,
    SeoPage,
  },
  layout: 'default',
  meta: {
    isPublic: true,
  },
  async asyncData({ $graphql, params, i18n, error }) {
    const variables = {
      locale: i18n.locale,
      slug: params.slug,
    }

    try {
      const response = await $graphql.default.request(
        contentPageQuery,
        variables,
      )

      const { page } = response

      if (!page) {
        return error({ statusCode: 404, message: "Page doesn't exist" })
      }

      return { pageData: page }
    } catch (e) {
      console.error(e)
      return error({
        statusCode: 500,
        message: 'There was an error loading the page',
      })
    }
  },
  data() {
    return {
      pageData: null,
    }
  },
  head() {
    if (!this.pageData.seo) {
      return
    }

    const alternates = this.pageData.slugLocales.filter((item) => {
      return item.slug !== this.pageData.slug
    })

    return {
      ...toHead(this.pageData.seo),
      link: alternates.map((item) => {
        return {
          rel: 'alternate',
          hreflang: item.locale,
          href: `${url}/${item.locale}/${item.slug}`,
        }
      }),
    }
  },
  computed: {
    isSEOCategory() {
      const { linkedSeoCategory } = this.pageData

      return !!linkedSeoCategory
    },
    featuredItems() {
      const { readMore } = this.pageData

      return readMore && readMore.links ? readMore.links : []
    },
    showFeaturedItems() {
      return this.featuredItems.length > 0
    },
    content() {
      const { content } = this.pageData

      return content.richText ? content.richText : {}
    },
  },
}
